import React from 'react';
import t from 'react-translate';
import AiQuestionsModalLoader from 'lecture_pages/components/quiz/ai-questions-modal-loader';
import { useSelector } from 'react-redux';
import { getCurrentUser } from 'redux/selectors/users';
import { getCurrentCourseActiveAICreationCommand } from 'redux/selectors/course';
import { css } from '@emotion/react';

const AiGenerationLoader = () => {
  const currentUser = useSelector(getCurrentUser);
  const { isGenerating } = useSelector((state) => state.app.aiCourseCreation);
  const currentAICreationCommand = useSelector(getCurrentCourseActiveAICreationCommand);
  const aiCreationRequester = currentAICreationCommand?.requester;

  const isAiCreationInProgress = !!currentAICreationCommand && (currentAICreationCommand?.inProgress || isGenerating);
  const isCurrentUserGenerating = isAiCreationInProgress && currentUser.id === aiCreationRequester?.id;
  const isAnotherUserGenerating = isAiCreationInProgress && currentUser.id !== aiCreationRequester?.id;

  const styles = css`
    .aniText {
      height: 25px;
      font-size: 18px;
    }
  `;

  return (
    <div css={styles}>
      {isCurrentUserGenerating && (
        <div>
          <AiQuestionsModalLoader showLoaderDescription={false} />
        </div>
      )}
      {isAnotherUserGenerating && (
        <div className='mb-6'>
          <AiQuestionsModalLoader
            customDescription={
              t.LECTURE_PAGES.LHS.NOVO_AI.GENERATING_CONTENT(
                aiCreationRequester?.firstName,
                aiCreationRequester?.lastName,
              )
            }
          />
        </div>
      )}
    </div>
  );
};
export default AiGenerationLoader;
